import ThisModule from "./ModalHelpText";

export default ThisModule;
